import { Box, Grid, Container } from "@mui/material";
import {
  ComponentHeader,
  ContactContent as ContactContentText,
  ContactForm,
} from "@/components/ui";
import { PAGE_COPY } from "@/constants/pages";

type Props = { defaultCountryCode?: string };

export const ContactContent = ({ defaultCountryCode }: Props) => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="flex-start">
          <Grid size={{ xs: 12, md: 6 }}>
            <ComponentHeader
              title={PAGE_COPY.sections.contactContent.title}
              subTitle=""
              ta="left"
              mb={1}
              component="h2"
            />
            <ContactContentText />
          </Grid>
          <ContactForm defaultCountryCode={defaultCountryCode} />
        </Grid>
      </Box>
    </Container>
  );
};
